import { Typography, CircularProgress } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectAllServiceAccounts, selectServiceAccountsLoadingStatus } from '../../store/service-account/service-accounts.slice'
import { selectAllZapierApps, selectZapierAppsLoadingStatus } from '../../store/zapier/zapier-apps.slice'
import { selectAllZapierTemplates, selectZapierTemplatesLoadingStatus } from '../../store/zapier/zapier-templates.slice'
import { selectAllZapierZaps, selectZapierZapsLoadingStatus } from '../../store/zapier/zapier-zaps.slice'

export function AsyncTest() {
  const zapierApps = useSelector(selectAllZapierApps)
  const zapierAppsLoadingStatus = useSelector(selectZapierAppsLoadingStatus)

  const zapierTemplates = useSelector(selectAllZapierTemplates)
  const zapierTemplatesLoadingStatus = useSelector(selectZapierTemplatesLoadingStatus)

  const zapierZaps = useSelector(selectAllZapierZaps)
  const zapierZapsLoadingStatus = useSelector(selectZapierZapsLoadingStatus)

  const serviceAccounts = useSelector(selectAllServiceAccounts)
  const serviceAccountsLoadingStatus = useSelector(selectServiceAccountsLoadingStatus)

  const headers = [
    { label: 'zapierApps', count: zapierApps.length, loadingStatus: zapierAppsLoadingStatus },
    { label: 'zapierTemplates', count: zapierTemplates.length, loadingStatus: zapierTemplatesLoadingStatus },
    { label: 'zapierZaps', count: zapierZaps.length, loadingStatus: zapierZapsLoadingStatus },
    { label: 'serviceAccounts', count: serviceAccounts.length, loadingStatus: serviceAccountsLoadingStatus },
    // { label: 'List 4', count: list4.length },
    // { label: 'List 5', count: list5.length },
  ]
  // const maxLength = Math.max(...headers.map((h) => h.count))
  const tdStyle = {
    borderStyle: 'solid',
    borderWidth: 'thin',
    verticalAlign: 'top',
    // animation: `updated 0.5s`,
  }
  return (
    <table>
      <style>
        {`
        @keyframes updated {
          0% { background-color: pink; }
          100% { background-color: none; }
        }
        li {
          animation: updated 0.5s;
        }
        `}
      </style>
      <thead>
        <tr style={{ fontSize: 'xxx-large' }}>
          {headers.map((header) => (
            <th key={header.label}>
              <Typography>
                {header.label} ({header.count})
              </Typography>
              <Typography>Loading Status: {header.loadingStatus}</Typography>
              {header.loadingStatus !== 'loading' ? null : <CircularProgress />}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={tdStyle}>
            <ul>
              {zapierApps.map((zapierApp) => (
                <li key={zapierApp.title}>{zapierApp.title}</li>
              ))}
            </ul>
          </td>
          <td style={tdStyle}>
            <ul>
              {zapierTemplates.map((zapierTemplate) => (
                <li key={zapierTemplate.id}>{zapierTemplate.id}</li>
              ))}
            </ul>
          </td>
          <td style={tdStyle}>
            <ul>
              {zapierZaps.map((zapierZap) => (
                <li key={zapierZap.id}>{zapierZap.id}</li>
              ))}
            </ul>
          </td>
          <td style={tdStyle}>
            <ul>
              {serviceAccounts.map((serviceAccount) => (
                <li key={serviceAccount.id}>
                  <pre>{JSON.stringify(serviceAccount, null, 2)}</pre>
                </li>
              ))}
            </ul>
          </td>

          {/* {!zapierApps[index] ? null : <td style={tdStyle}>{zapierApps[index].title || null}</td>}
            {!zapierTemplates[index] ? null : <td style={tdStyle}>{zapierTemplates[index].id || null}</td>}
            {!zapierZaps[index] ? null : <td style={tdStyle}>{zapierZaps[index].id || null}</td>}
            {!serviceAccounts[index] ? null : (
              <td style={tdStyle}>
                <pre>{JSON.stringify(serviceAccounts[index], null, 2)}</pre>
              </td>
            )} */}
          {/* <td>{list4[index]}</td>
            <td>{list5[index]}</td> */}
        </tr>
      </tbody>
    </table>

    // <>
    //   <Typography variant="h1">{zapierApps.length}</Typography>
    //   <ul>
    //     {zapierApps.map((zApp) => (
    //       <li>{`${zApp.title}`}</li>
    //     ))}
    //   </ul>
    // </>
  )
}
